import type { Narrative } from '../types';
import { parseBold } from '../format';

interface NarrativeCardProps {
  narrative: Narrative;
}

export const NarrativeCard = ({ narrative }: NarrativeCardProps) => {
  const { headline, content } = narrative;
  const narrativeTokens = parseBold(content);

  return (
    <li className={`narr-card${headline ? '' : ' narr-card--centre'}`}>
      <span className="narr-card-inner">
        {headline && <span className="narr-card-headline">{headline}</span>}
        {narrativeTokens.map((token, i) => (token.bold ? <strong key={i}>{token.text}</strong> : token.text))}
      </span>
    </li>
  );
};
